// Slack Connect web-item ids are `<addonKey>__<moduleKey>`. The addon key is bare in prod but
// suffixed on non-prod installs (e.g. `-ddev`, `-stg-east`), so match on prefix + module suffix.
const SLACK_CONNECT_APP_ID_PREFIX = 'confluence-chats-integration';

// Module suffixes being deprecated as part of the Connect deprecation. Add future modules here.
const DEPRECATED_CONNECT_MODULE_SUFFIXES = ['__page-config-dialog-trigger', '__profile'] as const;

/**
 * True when the web-item id is a deprecated Confluence↔Slack Connect UI module (across all envs).
 * Pure id check with no feature gate — callers must inline `fg(...)` at the callsite and AND it
 * with this helper, e.g. `isDeprecatedConnectWebItem(id) && fg('...')`.
 */
export const isDeprecatedConnectWebItem = (webItemId?: string | null): boolean =>
	Boolean(
		webItemId?.startsWith(SLACK_CONNECT_APP_ID_PREFIX) &&
		DEPRECATED_CONNECT_MODULE_SUFFIXES.some((suffix) => webItemId.endsWith(suffix)),
	);
